import React, { forwardRef } from 'react';
import './customInput.css';

const CustomInput = forwardRef(({
  placeholder,
  bg,
  handleChange,
  action = () => {},
  name,
  h = 'fit-content',
  w = '100%',
  mt = '0px',
  mb = '0px',
  ml = '0px',
  mr = '0px',
  pd = '0px',
  color = 'black',
  border = 'none',
  value = '',
  type = 'text',
  disabled = false
}, ref) => {
  const handleAction = (e) => {
    if (disabled) return; // No ejecutar action si está deshabilitado
    e.stopPropagation();
    action();
  };

  return (
    <input
      ref={ref} // Pasa el ref al contenedor
      className="customInput"
      placeholder={placeholder}
      onChange={handleChange}
      name={name}
      value={value}
      disabled={disabled}
      type={type}
      style={{
        background: bg,
        borderRadius: '5px',
        height: h,
        width: w,
        marginTop: mt,
        marginBottom: mb,
        marginLeft: ml,
        marginRight: mr,
        padding: pd,
        color,
        border
      }}
      onClick={handleAction}
    />
  );
});
export default CustomInput;
